export default __webpack_public_path__ + "static/media/phone.a473889d.svg";